import { Modal } from "@design-system/Modal";
import { type FC } from "react";
import { useEditOrDeleteProjectModalTranslations } from "./i18n";
import { Text } from "@design-system/Typography/Text";
import { useDeleteExternalQuestionnaire } from "@app/screens/ExternalQuestionnaires/data";

export const DeleteProjectModalContent: FC<{
    projectId: string;
    onDeleted: () => void;
}> = ({ projectId, onDeleted }) => {
    const { t, keys } = useEditOrDeleteProjectModalTranslations();
    const { deleteExternalQuestionnaire, isPending } =
        useDeleteExternalQuestionnaire();

    const handleDelete = () => {
        deleteExternalQuestionnaire(projectId);
        onDeleted();
    };

    return (
        <Modal.Content className="max-w-[600px]">
            <Modal.Header withClose>
                <Modal.Title>{t(keys.delete_project_modal_title)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Text>{t(keys.delete_project_modal_description)}</Text>
            </Modal.Body>
            <Modal.Footer>
                <Modal.CancelCTA>
                    {t(keys.delete_project_modal_cancel_button_label)}
                </Modal.CancelCTA>
                <Modal.ConfirmCTA
                    loading={isPending}
                    onClick={handleDelete}
                    preventClose
                    variant="flatDanger"
                >
                    {t(keys.delete_project_modal_confirm_button_label)}
                </Modal.ConfirmCTA>
            </Modal.Footer>
        </Modal.Content>
    );
};
